export const AppConstants = {
    webSiteUrlPattern:
        '^((https?://)?www\\.)+[a-zA-Z0-9-]+([-.]{1}[a-zd]+)*\\.[a-z]{2,5}(:[d]{1,5})?(/.*)?$'
};
